// work data

export const Work = [
    {
        id:1,
        name:"MZN-Restaurent",
        description:"It is build on top of the HTML with styledComponents and js for smooth scrolling animations.",
        tags:["html","css","styledComponents"],

        demo:"https://bit.ly/mzn00",
        github:"https://github.com/gitzaidhayat/Mzn-Restaurent"
    },
    {
        id:2,
        name:"Job listing website",
        description:"A Job listing website build in ReactJS. With searching and filtering functionalities.",
        tags:["react","sass"],
        
        // demo:"http://react-job-listing-website.codebucks27.vercel.app/",
        github:"https://github.com/gitzaidhayat"
        
    },
    {
        id:3,
        name:"Dev.to Clone",
        description:"A clone of Dev.to build using ReactJS. With realtime fetching of articles from dev.to using API.",
        tags:["react","api","sass"],
        
        // demo:"http://devto-clone-codebucks27.vercel.app/",
        github:"https://github.com/gitzaidhayat"
    },
    {
        id:4,
        name:"Sidebar Menu",
        description:"A cool looking sidebar menu build using ReactJS and styledComponents.It has really smooth animations.",
        tags:["react","styledComponents","react-router"],
        
        // demo:"https://react-sidebar.vercel.app/",
        github:"https://github.com/gitzaidhayat"
       
    },{
        id:5,
        name:"Todo App(React + Redux)",
        description:"A todo app build using Redux-toolkit and framer-motion for smooth animations.",
        tags:["react","redux","framer-motion"],
        
        // demo:"http://react-redux-todo-app-git-main-codebucks27.vercel.app/",
        github:"https://github.com/gitzaidhayat"

    },
    {
        id:6,
        name:"Responsive Navigation Menu",
        description:"A reponsive navbar menu component in ReactJS with react-router functionalities. Built from scratch.",
        tags:["react","react-router","css"],
        
        // demo:"http://react-responsive-navbar-codebucks27.vercel.app/",
        github:"https://github.com/gitzaidhayat"
        
    },
    
  
]   